import React from 'react';
import PropTypes from 'prop-types';

import { isLessThanBreakpoint } from 'dpl/util/grid';
import ClampedMultiLineText from 'dpl/common/components/ClampedMultiLineText';

const isLessThanMd = isLessThanBreakpoint('md');

export default function FAQItem({ question, answer }) {
  const nameLineHeight = isLessThanMd ? 20 : 24;

  return (
    <div className="BreederSearchResultsFAQItem f2 f3-sm ba br3 b--light-gray ph4 pv4 w-100 mb6">
      <p className="fw-medium mb2">{question}</p>
      <ClampedMultiLineText
        text={answer}
        numOfLines={2}
        fadeToButton
        moreText="Read more"
        lessText="Read less"
        className="BreederSearchResultsFAQItem__answer mid-gray"
        lineHeight={nameLineHeight}
        moreButtonClassName="black fw-medium"
        setInnerHTML
      />
    </div>
  );
}

FAQItem.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired
};
